"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Chart = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _highstock = _interopRequireDefault(require("highcharts/highstock"));
var _highchartsReactOfficial = _interopRequireDefault(require("highcharts-react-official"));
require('highcharts/indicators/indicators')(_highstock.default);
require('highcharts/indicators/pivot-points')(_highstock.default);
require('highcharts/indicators/macd')(_highstock.default);
const formatterCurrency = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD'
});
const formatterNumber = new Intl.NumberFormat('en-US');
const Chart = _ref => {
  let {
    title,
    subtitle,
    xAxisTitle,
    xAxisType,
    yAxisTitle,
    yAxisConnect,
    yAxisOpposite,
    yAxisFormat,
    seriesName,
    seriesType,
    seriesData,
    yAxisMin,
    isExport
  } = _ref;
  if (isExport) {
    require('highcharts/modules/exporting')(_highstock.default);
  }
  _highstock.default.setOptions({
    lang: {
      thousandsSep: ','
    }
  });
  let xAxis = [];
  xAxisTitle.forEach((title, index) => {
    xAxis.push({
      title: {
        text: title || ''
      },
      type: xAxisType[index] || '',
      dateTimeLabelFormats: {
        day: '%b %e'
      },
      min: seriesData[0][0][0],
      max: seriesData[0][6] ? seriesData[0][6][0] : seriesData[0][seriesData[0].length - 1][0]
    });
  });
  let yAxis = [];
  yAxisTitle.forEach((title, index) => {
    yAxis.push({
      title: {
        text: title || ''
      },
      opposite: yAxisOpposite.length ? yAxisOpposite[index] : false,
      min: yAxisMin.length ? yAxisMin[index] : null,
      labels: {
        format: yAxisFormat.length ? `${yAxisFormat[index]}{value}` : '{value}'
      }
    });
  });
  let series = [];
  seriesName.forEach((name, index) => {
    series.push({
      name: name || '',
      type: seriesType[index],
      data: seriesData[index],
      yAxis: yAxisConnect.length ? yAxisConnect[index] : 0
    });
  });
  const contructOptions = {
    series: series,
    xAxis: xAxis,
    yAxis: yAxis,
    title: {
      text: title
    },
    subtitle: {
      text: subtitle
    },
    tooltip: {
      pointFormatter: function () {
        let value = yAxisFormat && yAxisFormat[seriesName.indexOf(this.series.name)] === '$' ? formatterCurrency.format(this.y) : formatterNumber.format(this.y);
        return '<span style="color:' + this.series.color + '">' + this.series.name + '</span>: <b>' + value + '</b>';
      }
    },
    scrollbar: {
      enabled: true
    },
    credits: {
      enabled: false
    }
  };
  return /*#__PURE__*/_react.default.createElement(_highchartsReactOfficial.default, {
    highcharts: _highstock.default,
    constructorType: 'chart',
    options: contructOptions
  });
};
exports.Chart = Chart;
Chart.defaultProps = {
  title: '',
  subtitle: '',
  yAxisFormat: [],
  xAxisTitle: [],
  xAxisType: [],
  yAxisTitle: [],
  yAxisConnect: [],
  yAxisOpposite: [],
  yAxisMin: [],
  seriesName: [],
  seriesType: [],
  seriesData: [],
  isExport: false
};
Chart.propTypes = {
  /** The chart's main title. */
  title: _propTypes.default.string,
  /** The chart's main sub-title. */
  subtitle: _propTypes.default.string,
  /** List of xAxis title. */
  xAxisTitle: _propTypes.default.arrayOf(_propTypes.default.string),
  /** The type of axis. Can be one of `linear`, `logarithmic`, `datetime` or `category`. 
   * Please follow https://api.highcharts.com/highcharts/xAxis.type.
  */
  xAxisType: _propTypes.default.arrayOf(_propTypes.default.string),
  /** Format yAxis data and respective tooptip message. 
   * Example ['$', ''] where '' represents number. 
   */
  yAxisFormat: _propTypes.default.arrayOf(_propTypes.default.string),
  /** List of xAxis title. */
  yAxisTitle: _propTypes.default.arrayOf(_propTypes.default.string),
  /** When using dual or multiple y axes, this number defines which yAxis the particular series is connected to. */
  yAxisConnect: _propTypes.default.arrayOf(_propTypes.default.number),
  /** Whether to display the axis on the opposite side of the normal. The normal is on the left side for vertical axes and bottom for horizontal, so the opposite sides will be right and top respectively. This is typically used with dual or multiple axes. */
  yAxisOpposite: _propTypes.default.arrayOf(_propTypes.default.bool),
  /** The minimum value of the axis. If null the min value is automatically calculated. */
  yAxisMin: _propTypes.default.arrayOf(_propTypes.default.number),
  /** The name of the series as shown in the legend, tooltip etc. */
  seriesName: _propTypes.default.arrayOf(_propTypes.default.string),
  /** The type of series, for example line or column. */
  seriesType: _propTypes.default.arrayOf(_propTypes.default.string),
  /** An array of data points for the series. */
  seriesData: _propTypes.default.arrayOf(_propTypes.default.arrayOf(_propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])))),
  /** Allows users to download the chart as PDF, PNG, JPG or SVG vector images. It also allows printing the chart directly without distracting elements from the web page. */
  isExport: _propTypes.default.bool
};